import Tapi from '../../../assets/images/projects/tapi.png';
import Covido from '../../../assets/images/projects/covido.png';
import RecruitmentTask from '../../../assets/images/projects/recruitment_task.png';
import Hm from '../../../assets/images/projects/h&m.png';
import Nowhere from '../../../assets/images/projects/nowherehq.png';
import Superunion from '../../../assets/images/projects/superunion.png';
import Booksona from '../../../assets/images/projects/booksona.png';
import RtbHouseGaming from '../../../assets/images/projects/rtbhousegaming.png';

export const SLIDER_ITEMS = [
  {
    title: 'Tapi',
    description: 'My own web application',
    image: Tapi,
    sections: [
      // {
      //   title: 'About',
      //   description:
      //     'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.'
      // },
      {
        title: 'Duration',
        description: '6 months'
      },
      {
        title: 'Technologies',
        description: 'React.js, Express.js, SCSS, MongoDB, Redux'
      },
      {
        title: 'Link',
        description:
          '<a target="_blank" rel="noreferrer" title="https://tapi-5h1r.onrender.com/" href="https://tapi-5h1r.onrender.com/">Click here!</a>'
      }
    ]
  },
  {
    title: 'Superunion',
    description: 'Company project',
    image: Superunion,
    sections: [
      // {
      //   title: 'About',
      //   description:
      //     'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.'
      // },
      {
        title: 'Duration',
        description: '12 months'
      },
      {
        title: 'Technologies',
        description:
          'Next.js, Styled-components, Framer Motion, GlobalState, Strapi, MySQL, Three.js'
      },
      {
        title: 'Link',
        description:
          '<a target="_blank" rel="noreferrer" title="https://www.superunion.com" href="https://www.superunion.com">Click here!</a>'
      }
    ]
  },
  {
    title: 'Booksona',
    description: 'Company project',
    image: Booksona,
    sections: [
      // {
      //   title: 'About',
      //   description:
      //     'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.'
      // },
      {
        title: 'Duration',
        description: '3.5 months'
      },
      {
        title: 'Technologies',
        description: 'Next.js, Styled-components, Framer Motion, GlobalState, Parallax'
      },
      {
        title: 'Link',
        description:
          '<a target="_blank" rel="noreferrer" title="https://www.discoveryourbooksona.com" href="https://www.discoveryourbooksona.com">Click here!</a>'
      }
    ]
  },
  {
    title: 'RTB House Gaming',
    description: 'Company project',
    image: RtbHouseGaming,
    sections: [
      // {
      //   title: 'About',
      //   description:
      //     'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.'
      // },
      {
        title: 'Duration',
        description: '6 months'
      },
      {
        title: 'Technologies',
        description: 'Next.js, Styled-components, Framer Motion, Strapi, MySQL, Three.js'
      },
      {
        title: 'Link',
        description:
          '<a target="_blank" rel="noreferrer" title="https://gaming.rtbhouse.com/" href="https://gaming.rtbhouse.com/">Click here!</a>'
      }
    ]
  },
  {
    title: 'Recruitment Task',
    description: 'Project for recruitment purpose',
    image: RecruitmentTask,
    sections: [
      // {
      //   title: 'About',
      //   description:
      //     'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.'
      // },
      {
        title: 'Duration',
        description: '1 week'
      },
      {
        title: 'Technologies',
        description: 'Next.js, Styled-components'
      },
      {
        title: 'Link',
        description:
          '<a target="_blank" rel="noreferrer" title="https://twojpsycholog-recruitment-task-fvovf5wch-aandrys.vercel.app/" href="https://twojpsycholog-recruitment-task-fvovf5wch-aandrys.vercel.app/">Click here!</a>'
      }
    ]
  },
  {
    title: 'Simone Rocha x H&M',
    description: 'Company project',
    image: Hm,
    sections: [
      // {
      //   title: 'About',
      //   description:
      //     'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.'
      // },
      {
        title: 'Duration',
        description: '4 months'
      },
      {
        title: 'Technologies',
        description: 'Next.js, Styled-components, Strapi, MySQL, 8th Wall, Three.js'
      }
    ]
  },
  {
    title: 'Nowhere',
    description: 'Company project',
    image: Nowhere,
    sections: [
      // {
      //   title: 'About',
      //   description:
      //     'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.'
      // },
      {
        title: 'Duration',
        description: 'Few changes'
      },
      {
        title: 'Technologies',
        description: 'Next.js, Styled-components, Strapi, MySQL, Three.js'
      },
      {
        title: 'Link',
        description:
          '<a target="_blank" rel="noreferrer" title="https://www.nowherehq.com/" href="https://www.nowherehq.com/">Click here!</a>'
      }
    ]
  },
  {
    title: 'Covido',
    description: 'My own android application',
    image: Covido,
    sections: [
      // {
      //   title: 'About',
      //   description:
      //     'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.'
      // },
      {
        title: 'Duration',
        description: '4 months'
      },
      {
        title: 'Technologies',
        description: 'React Native, React Navigation, Redux'
      }
    ]
  }
];
